// @ts-ignore
import templateUrl from './ui-view-wrapper.html';

const UiViewWrapperComponent = {
  template: templateUrl
};
export default UiViewWrapperComponent;
